export default __webpack_public_path__ + "static/media/bar-basic.3d575b97.svg";